import { defineMessages } from 'react-intl';

export const messages: {
	heroName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subtitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	previewCta: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	statusDone: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	statusOnTrack: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	statusToDo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	statusAtRisk: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	heroName: {
		id: 'twg-microsite.heroIcons.heroName.non-final',
		defaultMessage: 'Teamwork Graph',
		description: 'Accessible heading text for the logged-out hero wordmark.',
	},
	subtitle: {
		id: 'twg-microsite.heroIcons.subtitle.non-final',
		defaultMessage:
			'Meet the graph that automatically builds your teamwork context from everywhere you work',
		description: 'Hero supporting copy beneath the wordmark on the logged-out home page.',
	},
	previewCta: {
		id: 'twg-microsite.heroIcons.previewCta.non-final',
		defaultMessage: 'See your graph preview',
		description: 'Call-to-action label inviting the user to preview their teamwork graph.',
	},
	statusDone: {
		id: 'twg-microsite.heroIcons.statusDone.non-final',
		defaultMessage: 'Done',
		description: 'Decorative status lozenge label in the logged-out hero.',
	},
	statusOnTrack: {
		id: 'twg-microsite.heroIcons.statusOnTrack.non-final',
		defaultMessage: 'On track',
		description: 'Decorative status lozenge label in the logged-out hero.',
	},
	statusToDo: {
		id: 'twg-microsite.heroIcons.statusToDo.non-final',
		defaultMessage: 'To do',
		description: 'Decorative status lozenge label in the logged-out hero.',
	},
	statusAtRisk: {
		id: 'twg-microsite.heroIcons.statusAtRisk.non-final',
		defaultMessage: 'At risk',
		description: 'Decorative status lozenge label in the logged-out hero.',
	},
});
